import React from 'react'

import { Helmet } from 'react-helmet'

import PagesliderConc from '../components/pageslider-conc'
import './conclusion.css'

const Conclusion = (props) => {
  const { increaseTrainingPercentage,type } = props;

  return (
    <div className="conclusion-container">
      <Helmet>
        <title>Conclusion - ORRS</title>
        <meta property="og:title" content="Conclusion - ORRS" />
      </Helmet>
      <div className="home-header">
        <div className="header-content">
            <img id="logo" src="\external\ORRSLogos_1113.png" alt="Logo" />
            <h1 className="home-text">The Opioid Rapid Response System (ORRS)<sup className='trademark'>TM</sup></h1>
        </div>
    </div>
      <PagesliderConc type={type} increaseTrainingPercentage={increaseTrainingPercentage} rootClassName="pageslider-conc-root-class-name"></PagesliderConc>
      <footer className="conclusion-footer">
        <span className="conclusion-text2">
          <span>
            The contents of this training were created by REAL Prevention. For
            inquiries on permission for use of these materials please contact
          </span>
          <span className="conclusion-text4">hechtpsu@gmail.com.</span>
          <span>
          </span>
        </span>
        <span className="conclusion-text6 Content">
          Copyright (2021) REAL Prevention. All rights reserved.
        </span>
      </footer>
    </div>
  )
}

export default Conclusion
